<template>
  <li class="category-tag">
    <a
      class="category-tag__item"
      :class="{ clicked: isClicked }"
      href="#"
      @click="toggleClick"
    >
      <slot />
    </a>
  </li>
</template>

<script>
export default {
  name: 'category-tag',
  data() {
    return {
      isClicked: false,
    }
  },
  methods: {
    toggleClick() {
      this.isClicked = !this.isClicked
    },
  },
}
</script>

<style scoped lang="scss">
.category-tag {
  list-style-type: none;

  &__item {
    font-size: 1rem;
    line-height: 1.5rem;
    color: $blue-03;
    text-align: center;
    padding: 0.25rem 0.5rem;
    width: max-content;
    font-weight: 600;
    transition: all 0.35s ease-in-out;
    text-decoration: none;

    &:hover {
      cursor: pointer;
      background-color: $blue-06;
    }
  }

  &__item.clicked {
    background-color: $blue-06;
  }
}
</style>
